import {
  InterviewLanguage
} from "../constants/languages.js";
const LessonOrder = {
  /** Participants must complete each lesson before the next one becomes available. */
  Sequential: "sequential",
  /** All lessons are available immediately and can be taken in any order. */
  Any: "any"
};
const InferenceStatus = {
  InProgress: "in_progress",
  Failed: "failed"
};
const InterviewRetakeMode = {
  Single: "single",
  Unlimited: "unlimited"
};
const AssessmentType = {
  /** Traditional assessment using the assessment resource and its associated custom field definitions. */
  Standard: "standard",
  /** Templated assessment geared towards field sales training. */
  FieldSalesTraining: "field_sales_training"
};
const defaultJobTypeSettings = Object.freeze({
  interview_languages: [InterviewLanguage.ENGLISH],
  multilang_languages: [],
  language_voice: null,
  resume_collection_type: null,
  should_force_fullscreen: false,
  should_record_video: false,
  auto_advance_assessment_score_threshold: null,
  welcome_message: null,
  outro_message: null,
  redirect_url: null,
  original_job_description: null,
  questions_status: null,
  assessment_status: null,
  assessment_type: AssessmentType.Standard,
  interview_retake_settings: {
    mode: InterviewRetakeMode.Single
  },
  course: null,
  lesson_order: LessonOrder.Sequential,
  playbook_id: null,
  should_email_chapter_grading_results_to_participant: false
});
function mapJobTypeDbToJobType(jobTypeDb) {
  return {
    ...jobTypeDb,
    settings: mapJobTypeSettingsDbToJobTypeSettings(jobTypeDb.settings)
  };
}
function mapJobTypeSettingsDbToJobTypeSettings(jobTypeSettingsDb) {
  return {
    ...defaultJobTypeSettings,
    ...jobTypeSettingsDb
  };
}
const ACME_CRM_COMPANY_ID = "19aac94b-24dc-42ac-bfcf-44c275493736";
const FOUNTAIN_INTERNAL_COMPANY_ID = "230d44ce-7c62-4631-9366-6e1486d7ab30";
export {
  ACME_CRM_COMPANY_ID,
  AssessmentType,
  FOUNTAIN_INTERNAL_COMPANY_ID,
  InferenceStatus,
  InterviewRetakeMode,
  LessonOrder,
  defaultJobTypeSettings,
  mapJobTypeDbToJobType,
  mapJobTypeSettingsDbToJobTypeSettings
};
//# sourceMappingURL=jobType.js.map
